
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[org]/purchase-orders/drafts",
      function () {
        return require("private-next-pages/[org]/purchase-orders/drafts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[org]/purchase-orders/drafts"])
      });
    }
  